import React from 'react'

import './style.scss'

export default function Edit ({ cb }) {
  // const [open, setOpen] = useState(true)
  const data = [
    'https://res.cloudinary.com/oddert/image/upload/v1571354267/Portfolio/tube_style_map_alt_colors_edited_2.jpg',
    'https://res.cloudinary.com/oddert/image/upload/v1571352462/Portfolio/template-sites-banner.png',
    'https://res.cloudinary.com/oddert/image/upload/v1571337553/Portfolio/2_Presentation_One_Finished.png',
    'https://res.cloudinary.com/oddert/image/upload/v1571337553/Portfolio/30_days_js.png',
    'https://res.cloudinary.com/oddert/image/upload/v1571337553/Portfolio/3_Presentation_One.png',
    'https://res.cloudinary.com/oddert/image/upload/v1571337552/Portfolio/2_Presentation_Two_Finished.png',
    'https://res.cloudinary.com/oddert/image/upload/v1571337552/Portfolio/3_Presentation_Two.png',
    'https://res.cloudinary.com/oddert/image/upload/v1571337552/Portfolio/4Y_Final_Render_2.jpg',
    'https://res.cloudinary.com/oddert/image/upload/v1571337551/Portfolio/1_PRESENTATION_ONE.png',
    'https://res.cloudinary.com/oddert/image/upload/v1571337551/Portfolio/1_PRESENTATION_TWO.png',
    'https://res.cloudinary.com/oddert/image/upload/v1571337551/Portfolio/zugriff_banner.png',
    'https://res.cloudinary.com/oddert/image/upload/v1571337551/Portfolio/tube_map_finsbury.png',
    'https://res.cloudinary.com/oddert/image/upload/v1571337551/Portfolio/tube_map_finsbury_af.png',
    'https://res.cloudinary.com/oddert/image/upload/v1571337551/Portfolio/voting_app_banner.png',
    'https://res.cloudinary.com/oddert/image/upload/v1571337551/Portfolio/tic_tac_toe_banner.png',
    'https://res.cloudinary.com/oddert/image/upload/v1571337550/Portfolio/thematic_banner.png',
    'https://res.cloudinary.com/oddert/image/upload/v1571337550/Portfolio/station_banner.jpg',
    'https://res.cloudinary.com/oddert/image/upload/v1571337550/Portfolio/simon_banner.png',
    'https://res.cloudinary.com/oddert/image/upload/v1571337550/Portfolio/stock_banner.png',
    'https://res.cloudinary.com/oddert/image/upload/v1571337550/Portfolio/sparda_banner.jpg',
    'https://res.cloudinary.com/oddert/image/upload/v1571337550/Portfolio/share_app.png',
    'https://res.cloudinary.com/oddert/image/upload/v1571337550/Portfolio/Screenshot_144__edited.jpg',
    'https://res.cloudinary.com/oddert/image/upload/v1571337550/Portfolio/fcc_leader_board_banner.png',
    'https://res.cloudinary.com/oddert/image/upload/v1571337550/Portfolio/backend-short-url.png',
    'https://res.cloudinary.com/oddert/image/upload/v1571337550/Portfolio/Flat_Design_UX_Colours.jpg',
    'https://res.cloudinary.com/oddert/image/upload/v1571337549/Portfolio/data_vis_plot_graph.png',
    'https://res.cloudinary.com/oddert/image/upload/v1571337549/Portfolio/dungeon_crawler_banner.png',
    'https://res.cloudinary.com/oddert/image/upload/v1571337549/Portfolio/data_vis_state_contiguity.png',
    'https://res.cloudinary.com/oddert/image/upload/v1571337549/Portfolio/directions_app.png',
    'https://res.cloudinary.com/oddert/image/upload/v1571337549/Portfolio/data_vis_tree_map.png',
    'https://res.cloudinary.com/oddert/image/upload/v1571337549/Portfolio/Render_1_active.jpg',
    'https://res.cloudinary.com/oddert/image/upload/v1571337549/Portfolio/Render_6_active.jpg',
    'https://res.cloudinary.com/oddert/image/upload/v1571337548/Portfolio/data_vis_heat_map.png',
    'https://res.cloudinary.com/oddert/image/upload/v1571337548/Portfolio/data_vis_meteor_map.png',
    'https://res.cloudinary.com/oddert/image/upload/v1571337548/Portfolio/CV_screenshot.png',
    'https://res.cloudinary.com/oddert/image/upload/v1571337548/Portfolio/recipe_book_banner.png',
    'https://res.cloudinary.com/oddert/image/upload/v1571337548/Portfolio/polymat_banner.jpg',
    'https://res.cloudinary.com/oddert/image/upload/v1571337548/Portfolio/data_vis_bar_chart.png',
    'https://res.cloudinary.com/oddert/image/upload/v1571337547/Portfolio/pinapathy_banner.png',
    'https://res.cloudinary.com/oddert/image/upload/v1571337547/Portfolio/nightlife_app_banner.png',
    'https://res.cloudinary.com/oddert/image/upload/v1571337547/Portfolio/conway2.png',
    'https://res.cloudinary.com/oddert/image/upload/v1571337547/Portfolio/notes_app.png',
    'https://res.cloudinary.com/oddert/image/upload/v1571337547/Portfolio/backend-metadata.png',
    'https://res.cloudinary.com/oddert/image/upload/v1571337547/Portfolio/backend-timestamp.png',
    'https://res.cloudinary.com/oddert/image/upload/v1571337547/Portfolio/chess_platform.png',
    'https://res.cloudinary.com/oddert/image/upload/v1571337547/Portfolio/Mini_Folio_Leaflet.png',
    'https://res.cloudinary.com/oddert/image/upload/v1571337547/Portfolio/backend-short-url_1.png',
    'https://res.cloudinary.com/oddert/image/upload/v1571337547/Portfolio/ngem_main.jpg',
    'https://res.cloudinary.com/oddert/image/upload/v1571337546/Portfolio/Mini_Folio_6th_Year_Art.png',
    'https://res.cloudinary.com/oddert/image/upload/v1571337546/Portfolio/ngem_banner.jpg',
    'https://res.cloudinary.com/oddert/image/upload/v1571337546/Portfolio/ngem_banner_1.jpg',
    'https://res.cloudinary.com/oddert/image/upload/v1571337546/Portfolio/more_code_projects.png',
    'https://res.cloudinary.com/oddert/image/upload/v1571337546/Portfolio/backend-req-header.png',
    'https://res.cloudinary.com/oddert/image/upload/v1571337546/Portfolio/backend-image.png',
    'https://res.cloudinary.com/oddert/image/upload/v1571337545/Portfolio/20160923_174643.jpg',
    'https://res.cloudinary.com/oddert/image/upload/v1571337545/Portfolio/Killer_Concept_Registered_Trademark.jpg',
    'https://res.cloudinary.com/oddert/image/upload/v1571337545/Portfolio/20160924_171901.jpg',
    'https://res.cloudinary.com/oddert/image/upload/v1571337545/Portfolio/20160924_171855.jpg',
    'https://res.cloudinary.com/oddert/image/upload/v1571337545/Portfolio/20131224_233835.jpg',
    'https://res.cloudinary.com/oddert/image/upload/v1571337545/Portfolio/20141029_212323.jpg',
    'https://res.cloudinary.com/oddert/image/upload/v1571337545/Portfolio/fusion_banner.png',
    'https://res.cloudinary.com/oddert/image/upload/v1571337545/Portfolio/20131224_233824.jpg',
    'https://res.cloudinary.com/oddert/image/upload/v1571337545/Portfolio/js_calculator_banner.png',
    'https://res.cloudinary.com/oddert/image/upload/v1571337544/Portfolio/20131224_232719.jpg',
    'https://res.cloudinary.com/oddert/image/upload/v1571337544/Portfolio/higher_assignment_banner.jpg',
    'https://res.cloudinary.com/oddert/image/upload/v1571337544/Portfolio/2013-12-25_10.58.49.jpg',
    'https://res.cloudinary.com/oddert/image/upload/v1581958045/Portfolio/root_to_root_banner_small.jpg',
    'https://res.cloudinary.com/oddert/image/upload/v1581958365/Portfolio/hold_store_display.jpg'
  ].reverse()

  // function toggleOpen () {
  //   setOpen(!open)
  // }

  return (
    <div className='Edit'>
      {data.map((url, idx) =>
        <button key={idx} onClick={cb ? () => cb({ url }) : ()=>{}} className='Edit-option'>
          <img alt={idx} src={url} />
        </button>
      )}
    </div>
  )
}
